export function updateSuspendData(suspendData, newSuspendData) {
    const suspendDataChanged = suspendData !== newSuspendData;
    return {
        value: suspendDataChanged ? newSuspendData : suspendData,
        changed: suspendDataChanged
    };
}
